import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'LOGIN_LOGOUT_HEADLINE',
    defaultMessage: 'Sie sind jetzt ausgeloggt!',
  },
  metaTitle: {
    id: 'LOGIN_LOGOUT_META_TITLE',
    defaultMessage: 'Sie sind erfolgreich ausgeloggt',
  },
  dayHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_DAY',
    defaultMessage: 'Schönen Tag!',
  },
  nightHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_NIGHT',
    defaultMessage: 'Schönen Abend!',
  },
  morningHeadline: {
    id: 'LOGIN_LOGOUT_HEADLINE_MORNING',
    defaultMessage: 'Schönen Start in den Tag!',
  },
  comeback: {
    id: 'LOGIN_LOGOUT_COMEBACK',
    defaultMessage: 'Wenn Sie XING weiter nutzen wollen, {loginLink}.',
  },
  loginLinkText: {
    id: 'LOGIN_LOGOUT_LOGIN_LINK_TEXT',
    defaultMessage: 'loggen Sie sich bitte erneut ein',
  },
  surveySuccess: {
    id: 'LOGIN_LOGOUT_SURVEY_SUCCESS_MESSAGE',
    defaultMessage: 'Vielen Dank für Ihre Teilnahme.',
  },
  surveySubmit: {
    id: 'LOGIN_LOGOUT_SURVEY_SUBMIT_LABEL',
    defaultMessage: 'Absenden',
  },
  surveyTextLabel: {
    id: 'LOGIN_LOGOUT_SURVEY_FREE_TEXT_LABEL',
    defaultMessage: 'Anderer Grund? (max. 160 Zeichen)',
  },
  surveyAnswerNeverForget: {
    id: 'LOGIN_LOGOUT_SURVEY_ANSWER_NEVER_FORGET',
    defaultMessage: 'Ich vergesse meine Login Daten nie.',
  },
  surveyAnswerNoTrust: {
    id: 'LOGIN_LOGOUT_SURVEY_ANSWER_NO_TRUST',
    defaultMessage: 'Ich vertraue XING nicht.',
  },
  surveyAnswerNotMyDevice: {
    id: 'LOGIN_LOGOUT_SURVEY_ANSWER_NOT_MY_DEVICE',
    defaultMessage: 'Ich benutze gerade ein Gerät, das nicht mir gehört.',
  },
  surveyHeadline: {
    id: 'LOGIN_LOGOUT_SURVEY_HEADLINE',
    defaultMessage: 'Verraten Sie uns, warum Sie sich gerade ausgeloggt haben?',
  },
  surveyErrorRequired: {
    id: 'LOGIN_LOGOUT_SURVEY_ERROR_REQUIRED',
    defaultMessage:
      'Bitte geben Sie einen Grund an, warum Sie sich ausgeloggt haben.',
  },
});
